const CHECKBOX_LIST_STYLE_ATTRIBUTE_VALUE = "checkbox";
export {
  CHECKBOX_LIST_STYLE_ATTRIBUTE_VALUE
};
//# sourceMappingURL=checkbox-list-style.js.map
